import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Email obfuscation
  const emailParts = ["info", "metodocontabile", "it"];
  const handleEmailClick = () => {
    const email = `${emailParts[0]}@${emailParts[1]}.${emailParts[2]}`;
    window.location.href = `mailto:${email}`;
  };

  return (
    <footer
      className="bg-brand-primary text-white py-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-heading text-2xl font-bold mb-4">
              Metodo Contabile
            </h3>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              Studio tributarista e di consulenza fiscale. 
              Una realtà tutta al femminile dal 1998.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4 mt-4">
              <a
                href="https://www.facebook.com/metodocontabilesrlsandanieledelfriuliud/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/metodocontabile/?hl=it"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.instagram.com/metodocontabile/?hl=it"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">
              Link Utili
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/servizi"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-servizi"
                >
                  Servizi
                </Link>
              </li>
              <li>
                <Link
                  to="/risorse"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-risorse"
                >
                  Risorse e Strumenti
                </Link>
              </li>
              <li>
                <Link
                  to="/contatti"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-contatti"
                >
                  Contatti
                </Link>
              </li>
              <li>
                <a
                  href="https://www.metodocontabile.it/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="footer-link-blog"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">
              Contatti
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-white/80 text-sm">
                  Via Umberto I, 28<br />
                  33038 San Daniele del Friuli (UD)
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="flex-shrink-0" />
                <a
                  href="tel:+390432942144"
                  className="text-white/80 hover:text-white transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  0432 942144
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="flex-shrink-0" />
                <button
                  onClick={handleEmailClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                  data-testid="footer-email"
                >
                  info [at] metodocontabile.it
                </button>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="mt-1 flex-shrink-0" />
                <span className="text-white/80 text-sm">
                  Lun - Ven: 9:00 - 18:00
                </span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">
              Informazioni Legali
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white/80 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-policy"
                  className="text-white/80 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-cookie"
                >
                  Cookie Policy
                </Link>
              </li>
              <li className="text-white/60 text-xs mt-4">
                P.IVA: 02030830307
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {currentYear} Metodo Contabile S.r.l. - Tutti i diritti riservati
          </p>
          <p className="text-white/40 text-xs mt-2">
            Tributariste qualificate e certificate UNI11511 L. 4/2013
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
